import { useRef } from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

import { useAppSelector } from 'hooks/redux'
import { PayerSelectionForm } from './PayerSelection'
import { Order } from 'store/types'
import { useUpdatePayerMutation } from 'store/services/dmeOrder'

interface IProps {
  order: Order
  open: boolean
  onClose: () => void
}

export const UpdateInsuranceModal = ({ order, open, onClose }: IProps) => {
  const submitRef = useRef<() => void>()
  const [updatePayer] = useUpdatePayerMutation()
  const currentOfficeId = useAppSelector((state) => state.init.currentOfficeId)

  // A client-billed order's payer is set from the office profile and cannot
  // be edited: the form is read-only and there is nothing to submit.
  const insuranceLocked = order?.billingType === 'CLIENT_BILL'

  const submitForm = async (payload) => {
    try {
      await updatePayer({
        orderId: order.id,
        payers: payload,
      }).unwrap()
      onClose()
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <Modal centered show={open} onHide={onClose} size="lg">
      <Modal.Header>
        <Modal.Title>EDIT INSURANCE INFORMATION</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {insuranceLocked && (
          <div
            className="py-2 px-4 mb-3"
            style={{ background: '#e9ecef', border: '1px solid #ced4da', borderRadius: '5px' }}>
            <div className="text-bold">
              <i className="fas fa-lock mr-2" />
              Client bill — insurance is locked
            </div>
            <div style={{ fontSize: '0.875rem' }}>
              This order is billed to your office. Its payer was set from the office profile and cannot
              be changed here.
            </div>
          </div>
        )}
        <PayerSelectionForm
          officeId={currentOfficeId}
          payers={order.payers}
          verificationResult={order?.state?.VERIFICATION?.RESULT}
          submitForm={submitForm}
          submitRef={submitRef}
          locked={insuranceLocked}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onClose}>
          {insuranceLocked ? 'Close' : 'Cancel'}
        </Button>
        {!insuranceLocked && (
          <Button autoFocus variant="primary" onClick={() => submitRef.current()}>
            Submit
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  )
}
